// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css.css
// module id = bc0p
// module chunks = 1